/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Entercustomlabel6Inputs */

const en_coinvestments_lpdealoverviewcontent_entercustomlabel6 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Entercustomlabel6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter custom label...`)
};

/**
* | output |
* | --- |
* | "Enter custom label..." |
*
* @param {Coinvestments_Lpdealoverviewcontent_Entercustomlabel6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_entercustomlabel6 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Entercustomlabel6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Entercustomlabel6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_entercustomlabel6(inputs)
});
export { coinvestments_lpdealoverviewcontent_entercustomlabel6 as "coInvestments_lpDealOverviewContent_enterCustomLabel" }